export default __webpack_public_path__ + "static/media/QualityEvaluation.b1558a11.png";